import http from '../../../../api/http'

function retrieveAllPartnerPaging(paramObj) {
    return http.post('/admin/partner/retrieveAllPartner', paramObj)
}

function retrievePartner(partnerId) {
    return http.get(`admin/partner/retrievePartner?partnerId=${partnerId}`)
}

function createPartner(paramObj) {
    return http.post('/admin/partner/createPartner', paramObj)
}

function updatePartner(paramObj) {
    return http.post('/admin/partner/updatePartner', paramObj)
}

function deletePartner(paramObj) {
    return http.post('/admin/partner/deletePartner', paramObj)
}

function retrieveAllPartnerForSelect() {
    return http.get(`admin/partner/retrieveAllPartnerForSelect`)
}

export default {
    retrieveAllPartnerPaging,
    retrievePartner,
    createPartner,
    updatePartner,
    deletePartner,
    retrieveAllPartnerForSelect
}
